






















import { Component, Vue, Prop } from "vue-property-decorator";

@Component({})
class Metadata extends Vue {
  @Prop({ type: [String, Date, Object], default: "" }) lastUpdated!: string;
  @Prop({ type: String, default: "" }) source!: string;
  @Prop({ type: String, default: "" }) updatedBy!: string;
  @Prop({ type: String, default: "" }) createdBy!: string;

  get updateDate(): string {
    if (!this.lastUpdated) return "";
    const date = new Date(this.lastUpdated);
    if (String(date) === "Invalid Date") return String(this.lastUpdated);
    const pad = (n: number) => (n < 10 ? `0${n}` : `${n}`);
    const dmy = `${pad(date.getDate())}.${pad(
      date.getMonth() + 1
    )}.${date.getFullYear()}`;
    const hms = `${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(
      date.getSeconds()
    )}`;
    return `${dmy} ${hms}`;
  }
}
export default Metadata;
